import axios from 'axios'

 function checkSession() {
    return axios.get('api/auth/authStatus')
}

function closeSession() {
    return axios.get('api/auth/closeSession')
}

function login(data){
    return axios.post('api/auth/login', data)
}

function permisos(data){
    return axios.post('api/auth/permisos', data)
}

function getMenu() {
    return axios.get('api/auth/getMenu')
}

function getDataHeader() {
    return axios.get('api/auth/getDataHeader')
}



export {
    checkSession,
    login,
    getMenu,
    closeSession,
    permisos,
    getDataHeader
}
